
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class PosSalesPromoGrid extends Serenity.EntityGrid<PosSalesPromoRow, any> {
        protected getColumnsKey() { return 'Retail.PosSalesPromo'; }
        protected getDialogType() { return PosSalesPromoDialog; }
        protected getIdProperty() { return PosSalesPromoRow.idProperty; }
        protected getInsertPermission() { return PosSalesPromoRow.insertPermission; }
        protected getLocalTextPrefix() { return PosSalesPromoRow.localTextPrefix; }
        protected getService() { return PosSalesPromoService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}